import { Chip, Theme, useTheme } from '@mui/material';

const NumberChip = (props: { value: number }) => {
    const { value } = props;
    const theme: Theme = useTheme();

    return (
        <Chip
            label={value.toLocaleString()}
            color={value !== 0 ? 'success' : 'default'}
            sx={{
                width: '100%',
                fontFamily: 'monospace',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                justifyContent: 'flex-end',
                color: theme.palette.common.white,
                background: value !== 0 ? theme.palette.success.main : theme.palette.grey[300],
                '& .MuiChip-root': {},
            }}
        />
    );
};

export default NumberChip;
